/**
 * 设备状态信息
 */
import React, { useState } from 'react';
import { Button } from 'antd';
import dayjs from 'dayjs';
import CommonTable from '@/components/commonTable';
import ExportButton from '@/components/exportButton';
import { getKlsDeviceStatusColumns } from '@/columns/klsDeviceStatus';
import { useTable } from '@/utils/useTable';
import { isKlsV3Aeb } from '@/utils/device';
import {
  carDiagnosisDeviceTimeRangeRequest,
  carDiagnosisDeviceTimeRangeRequestPath
} from '@/service/carDiagnosis';
import styles from '@/styles/pageContent.module.scss';

const DeviceStatusTable = (props: any) => {
  const { beginTime, endTime, virtualCarId, mcuType } = props;
  const [searchParams, setSearchParams] = useState({
    beginTime: beginTime,
    endTime: endTime || dayjs().format('YYYY-MM-DD HH:mm:ss'),
    carId: virtualCarId
  }); // 搜索相关的参数
  const { page, limit, loading, data, totalCount, onPageChange } = useTable({
    requestFunc: carDiagnosisDeviceTimeRangeRequest,
    initPageSize: 40,
    searchParams
  });

  // 获取导出参数
  const getExportParams = () => {
    return {
      ...searchParams,
      export: true
    };
  };

  // 刷新列表数据
  const onRefresh = () => {
    // 没有结束时间的检测任务使用当前时间作为endTime
    setSearchParams({
      ...searchParams,
      endTime: endTime || dayjs().format('YYYY-MM-DD HH:mm:ss')
    });
  };

  return (
    <div className={styles.commonTableWrapper}>
      <div className={styles.operateBox} style={{ textAlign: 'right' }}>
        <Button onClick={onRefresh}>刷新</Button>
        <ExportButton
          type="primary"
          url={carDiagnosisDeviceTimeRangeRequestPath}
          fileName="设备状态信息"
          getParamsFunc={getExportParams}
          requestMethod="GET"
          permissionKey="/car-admin/device-inspect/export"
        />
      </div>
      <CommonTable
        rowKey="id"
        columns={getKlsDeviceStatusColumns(data, isKlsV3Aeb(mcuType))}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
        size="small"
      />
    </div>
  );
};

export default DeviceStatusTable;
